import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  { path: 'meeting-rooms/meeting-rooms-booking', pathMatch: 'full', redirectTo: 'meeting-room' },
  { path: 'meeting-rooms', pathMatch: 'full', redirectTo: 'meeting-room' },
  {
    path: 'manage-booking',
    loadChildren: () => import('./modules/manage-booking/manage-booking.routes').then((m) => m.MANAGE_BOOKING_ROUTES)
  },
  { path: '', loadChildren: () => import('./modules/booking/booking.routes').then((m) => m.BOOKING_ROUTES) },
  { path: '**', redirectTo: 'meeting-room' }
];
